// Windows Ready Handler
 	
(function($) {
	
    $(document).ready(function(){
		console.log(window.scrollY);
		var header = document.querySelector('#site-header')
		if(100 > window.scrollY) {
			header.classList.add('bg-transparent');
			header.classList.remove('scrolled-header');
		} else {
			header.classList.remove('bg-transparent');
			header.classList.add('scrolled-header');
		}
    });

}(jQuery));